/* CLNR — running timecode in the nav, hero, reel and footer.
   Honours prefers-reduced-motion by parking on a static frame. */
(function(){
  function boot(){
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var els = [].slice.call(document.querySelectorAll('#tc, .tc2, #tcf'));
    if (!els.length) return;
    if (reduce) { els.forEach(function(e){ e.textContent = '00:00:04:12'; }); return; }
    var start = performance.now();
    function pad(n){ return (n < 10 ? '0' : '') + n; }
    function tick(now){
      var s = (now - start) / 1000, f = Math.floor((s % 1) * 24), t = Math.floor(s);
      var str = pad(Math.floor(t / 3600) % 24) + ':' + pad(Math.floor(t / 60) % 60) + ':' + pad(t % 60) + ':' + pad(f);
      for (var i = 0; i < els.length; i++) els[i].textContent = str;
      requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  // Theme editor re-renders sections without a page load.
  document.addEventListener('shopify:section:load', boot);
})();

/* CLNR — email capture modal.
   Opens once per visitor per remember-window, never after they sign up.
   Every storage call is wrapped: private windows and blocked site data
   throw on access, and a popup is not worth breaking the page over. */
(function(){
  function store(op, key, val){
    try {
      if (op === 'get') return window.localStorage.getItem(key);
      if (op === 'set') { window.localStorage.setItem(key, val); return true; }
    } catch (e) { return null; }
  }

  function boot(){
    var el = document.getElementById('ep');
    if (!el || el.dataset.bound) return;
    el.dataset.bound = '1';

    var panel   = el.querySelector('.ep-panel');
    var key     = el.dataset.key || 'clnr-ep';
    var forced  = !!el.querySelector('[data-ep-success]');
    var opened  = false;
    var lastFocus = null;

    var state = store('get', key);
    if (state === 'subscribed') return;
    if (!forced && state) {
      var until = parseInt(state, 10);
      if (!isNaN(until) && Date.now() < until) return;
    }

    function focusables(){
      return panel.querySelectorAll('a[href],button:not([disabled]),input:not([type=hidden]),textarea,select,[tabindex]:not([tabindex="-1"])');
    }

    function open(){
      if (opened) return;
      opened = true;
      lastFocus = document.activeElement;
      el.hidden = false;
      // Force a reflow rather than waiting on rAF: a backgrounded tab never
      // runs the callback, which would leave the modal open, focus-trapped
      // and scroll-locked at opacity 0.
      void el.offsetWidth;
      el.classList.add('on');
      document.documentElement.style.overflow = 'hidden';
      var f = focusables();
      (f.length ? f[0] : panel).focus();
      document.addEventListener('keydown', onKey);
    }

    function close(remember){
      if (!opened) return;
      opened = false;
      el.classList.remove('on');
      document.documentElement.style.overflow = '';
      document.removeEventListener('keydown', onKey);
      if (remember !== false) {
        var days = parseInt(el.dataset.rememberDays, 10) || 30;
        store('set', key, String(Date.now() + days * 864e5));
      }
      window.setTimeout(function(){ if (!opened) el.hidden = true; }, 240);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    function onKey(e){
      if (e.key === 'Escape') { close(); return; }
      if (e.key !== 'Tab') return;
      var f = focusables();
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    el.addEventListener('click', function(e){
      if (e.target.closest('[data-ep-close]')) { e.preventDefault(); close(); }
    });

    var form = el.querySelector('form');
    if (form) form.addEventListener('submit', function(){ store('set', key, 'subscribed'); });

    if (forced) { open(); return; }

    var trigger = el.dataset.trigger || 'scroll';
    var delay   = (parseInt(el.dataset.delay, 10) || 15) * 1000;

    if (trigger === 'time') {
      window.setTimeout(open, delay);
    } else if (trigger === 'exit') {
      var fine = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      if (fine) {
        document.addEventListener('mouseout', function onOut(e){
          if (!e.relatedTarget && e.clientY <= 0) { document.removeEventListener('mouseout', onOut); open(); }
        });
      } else {
        window.setTimeout(open, delay);
      }
    } else {
      var pct = parseInt(el.dataset.scroll, 10) || 45;
      var onScroll = function(){
        var h = document.documentElement.scrollHeight - window.innerHeight;
        if (h <= 0) return;
        if ((window.scrollY / h) * 100 >= pct) {
          window.removeEventListener('scroll', onScroll);
          open();
        }
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();

/* CLNR — mobile navigation.
   The inline links are hidden under 760px, so this is the only way to
   navigate on a phone. Kept in sync with the breakpoint in clnr.css. */
(function(){
  var BREAKPOINT = 760;

  function boot(){
    var btn  = document.getElementById('nav-toggle');
    var menu = document.getElementById('nav-menu');
    if (!btn || !menu || btn.dataset.bound) return;
    btn.dataset.bound = '1';

    function open(){
      menu.hidden = false;
      // Forced reflow rather than rAF: a backgrounded tab never runs the
      // callback and the panel would sit open at opacity 0.
      void menu.offsetWidth;
      menu.classList.add('on');
      btn.setAttribute('aria-expanded', 'true');
      document.documentElement.style.overflow = 'hidden';
      document.addEventListener('keydown', onKey);
    }

    function close(focusBtn){
      menu.classList.remove('on');
      btn.setAttribute('aria-expanded', 'false');
      document.documentElement.style.overflow = '';
      document.removeEventListener('keydown', onKey);
      window.setTimeout(function(){
        if (btn.getAttribute('aria-expanded') === 'false') menu.hidden = true;
      }, 220);
      if (focusBtn !== false) btn.focus();
    }

    function isOpen(){ return btn.getAttribute('aria-expanded') === 'true'; }
    function onKey(e){ if (e.key === 'Escape') close(); }

    btn.addEventListener('click', function(){ isOpen() ? close() : open(); });

    // A link to an anchor on the current page does not reload it, so the
    // panel has to be dismissed by hand or it covers the destination.
    menu.addEventListener('click', function(e){
      if (e.target.closest('a')) close(false);
    });

    window.addEventListener('resize', function(){
      if (window.innerWidth > BREAKPOINT && isOpen()) close(false);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();

/* CLNR — the wordmark reel, one column per letter.
   Every column spins through the letters that can actually land in that
   position across the five words, and stops left to right.

   Each slot's width animates to the natural advance width of the letter
   landing in it. Holding every slot at its widest candidate is what stops
   the word shuffling sideways mid-spin, but left there it renders the
   wordmark monospaced and loose — wrong beside tightly kerned display
   type. Animating the width alongside the spin gets both. */
(function(){
  var SPIN_MS  = 900;
  var STAGGER  = 70;
  var EASE     = 'cubic-bezier(.16,.84,.26,1)';
  var COPIES   = 4;

  function boot(){
    var h = document.getElementById('cyc');
    if (!h || h.dataset.bound) return;
    var reel = h.querySelector('.cyc-reel');
    if (!reel) return;

    var words = [].slice.call(reel.children).map(function(el){ return el.textContent.trim(); })
                  .filter(function(w){ return w.length; });
    if (words.length < 2) return;
    h.dataset.bound = '1';

    var count  = words.length;
    var maxLen = words.reduce(function(m,w){ return Math.max(m, w.length); }, 0);

    // Measure in the real type, at the real size.
    var probe = document.createElement('span');
    probe.className = 'cyc-ch';
    probe.style.cssText = 'position:absolute;visibility:hidden;white-space:pre;left:-9999px';
    reel.parentNode.appendChild(probe);
    function widthOf(ch){ probe.textContent = ch === '' ? ' ' : ch; return probe.getBoundingClientRect().width; }

    var lineH = reel.parentNode.querySelector('.cyc-sizer').getBoundingClientRect().height;

    var grid = document.createElement('span');
    grid.className = 'cyc-letters';
    var cols = [];

    var slotWidths = [];   // slotWidths[wordIndex][slotIndex]
    words.forEach(function(){ slotWidths.push([]); });

    for (var i = 0; i < maxLen; i++) {
      var candidates = words.map(function(w){ return w[i] || ''; });
      candidates.forEach(function(ch, wi){ slotWidths[wi][i] = ch === '' ? 0 : widthOf(ch); });

      var slot = document.createElement('span');
      slot.className = 'cyc-slot';
      slot.style.width  = slotWidths[0][i] + 'px';
      slot.style.height = lineH + 'px';

      var col = document.createElement('span');
      col.className = 'cyc-col';
      for (var c = 0; c < COPIES; c++) {
        candidates.forEach(function(ch){
          var g = document.createElement('span');
          g.className = 'cyc-ch';
          g.style.height = lineH + 'px';
          g.textContent = ch === '' ? ' ' : ch;
          col.appendChild(g);
        });
      }
      slot.appendChild(col);
      grid.appendChild(slot);
      cols.push(col);
    }

    probe.parentNode.removeChild(probe);
    reel.parentNode.replaceChild(grid, reel);

    function place(col, p, animate, delay){
      col.style.transition = animate
        ? ('transform ' + SPIN_MS + 'ms ' + EASE + ' ' + delay + 'ms')
        : 'none';
      col.style.transform = 'translateY(' + (-p * lineH) + 'px)';
    }

    function widths(wordIndex, animate, delayFor){
      cols.forEach(function(col, i){
        var slot = col.parentNode;
        slot.style.transition = animate
          ? ('width ' + SPIN_MS + 'ms ' + EASE + ' ' + delayFor(i) + 'ms')
          : 'none';
        slot.style.width = slotWidths[wordIndex][i] + 'px';
      });
    }

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) {
      cols.forEach(function(col){ place(col, count - 1, false, 0); });
      widths(count - 1, false, function(){ return 0; });
      return;
    }

    var pos = 0, busy = false;
    cols.forEach(function(col){ place(col, 0, false, 0); });
    widths(0, false, function(){ return 0; });

    function spin(){
      if (busy) return;
      busy = true;
      var target = pos + count * 2 + 1;
      cols.forEach(function(col, i){ place(col, target, true, i * STAGGER); });
      widths(target % count, true, function(i){ return i * STAGGER; });
      window.setTimeout(function(){
        pos = target % count;
        cols.forEach(function(col){ place(col, pos, false, 0); });
        void grid.offsetWidth;   // commit the jump before the next spin
        busy = false;
      }, SPIN_MS + STAGGER * cols.length + 60);
    }

    var hold = (parseFloat(h.dataset.speed) || 2) * 1000;
    window.setInterval(spin, Math.max(hold, SPIN_MS + STAGGER * cols.length + 700));
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
